import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Position } from '@capacitor/geolocation';
import { IonPopover } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { ICoords } from 'src/app/core/models/interfaces/coords';
import { IGenericResponse } from 'src/app/core/models/interfaces/i-generic-response';
import { IGeoJSONObj } from 'src/app/core/models/interfaces/map-fn-props';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LocationService } from 'src/app/core/services/location.service';
import { MapService } from 'src/app/core/services/map.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { ErrorModalComponent } from '../error-modal/error-modal.component';

const mapHintTextListForDrawing = ["zoom_in_to_first_point", "add_other_clock_wise", "add_other_clock_wise", "touche_first_to_complete"]
const mapHintTextListForParcelUpdate = "click_to_update_farm_borders"

@Component({
  selector: 'app-add-field',
  templateUrl: './add-field.component.html',
  styleUrls: ['./add-field.component.scss'],
})
export class AddFieldComponent implements OnInit {
  @ViewChild('popover') popover: IonPopover;
  renderBtns: boolean = true;
  private _locationListener: Subscription
  selectedMode: "parcel_inquiry" | "manual_drawing" | "not_selected" = null
  findFieldModalActions = {
    "drawLocationSelected": (ev: IGenericResponse<ICoords>) => {
      this.selectedMode = "manual_drawing";
      if (ev && ev.IsSuccess && ev.Data)
        this.mapService.flyToLocation({ map: this.map, latitude: ev.Data.latitude, longitude: ev.Data.longitude, scope: this })
      this.drawField();
    },
    "startParcelInquiry": () => {
      this.selectedMode = "parcel_inquiry"
      // this.startParcelInquery()
    },
    "canceled": (ev) => {
      this.selectedMode = "not_selected"
      this.navigationService.goBack()
    }
  }
  parcelGeoJson: IGeoJSONObj = null
  mapId = "addFieldMap"
  mapCenter: { lat, lng } = null
  hideMap = true;
  map = null
  showHint: boolean = false
  hintText: string = mapHintTextListForDrawing[0]
  mapActions = {

  }
  currentLocation: Position = null;
  querySubs: Subscription;
  deviceId: string;
  deviceType: string;
  constructor(
    private loadingService: LoadingService,
    public navigationService: NavigationService,
    private mapService: MapService,
    private modalService: ModalService,
    private utilsService: UtilsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private farmApiService: FarmApiService,
    private locationService: LocationService) {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e.IsSuccess) {
        this.deviceType = e.Data ? 'filiz' : 'trap'
      }
    })
  }

  ngOnInit() { }

  ionViewDidEnter() {
    // setTimeout(() => {
    //   this.router.navigate(["/common/enter-device"], {
    //     queryParams: {
    //       initialPage: 2,
    //       deviceId: this.deviceId
    //     }
    //   });

    // }, 5000);

  }
  marker
  ionViewWillEnter() {
    this.loadingService.showLoading();
    this._locationListener = LocationService.WatchMyLocation().subscribe(response => {
      this.hideMap = false;
      this.loadingService.hideLoading();
      if (this.map) {
        if (response)
          this.marker = this.mapService.setMyLocationPin({ callback: null, coords: response.coords, currentMarker: this.marker, map: this.map, scope: this })
      }
    });
    if (LocationService.isLocationAvailable) {
      this._locationListener = LocationService.WatchMyLocation().subscribe(response => {
        if (this.map) {
          if (response)
            this.marker = this.mapService.setMyLocationPin({ callback: null, coords: response.coords, currentMarker: this.marker, map: this.map, scope: this })
        }
      })

      LocationService.GetMyCurrentLocation().then(response => {
        if (response.IsSuccess && response.Data) {
          this.mapCenter = { lat: response.Data.latitude, lng: response.Data.longitude }
          this.hideMap = false
        } else {
          this.loadingService.hideLoading();
          this._setLocationFromIp()
        }
      }).catch(error => {
        this._setLocationFromIp()
      })
    }

  }
  private _setLocationFromIp() {
    LocationService.GetLocationFromIp().then(ipResponse => {
      this.loadingService.hideLoading();
      if (ipResponse)
        this.mapCenter = { lat: ipResponse.latitude, lng: ipResponse.longitude }
      else
        this.mapCenter = { lat: 51.4874505, lng: -0.0304749 }
      this.hideMap = false
    }).catch(err => {
      this.loadingService.hideLoading();
      this.mapCenter = { lat: 51.4874505, lng: -0.0304749 }
      this.hideMap = false
    })
  }

  ionViewWillLeave() {
    if (this._locationListener)
      this._locationListener.unsubscribe();

    // if (this.map)
    //   this.mapService.destroyMap(this.map)

    this.hideMap = true;
    this.draw = null;
    this.calculatedArea = -1;
    if(this.querySubs)
    this.querySubs.unsubscribe()
    this.querySubs = undefined;
  }

  mapLoaded(ev) {
    this.loadingService.hideLoading();
    this.map = ev;
      this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
        if (e["type"]) {
          if (e["type"] == "drawLocationSelected") {
            let ev = this.farmApiService.data
            this.selectedMode = "manual_drawing";
            if (ev && ev.IsSuccess && ev.Data) {
              let callback = (event) => {
                this.calculatedArea = this.mapService.calculateArea(event, this.draw)
              }
              this.storageService.get(StorageKeys.DRAWING).then(e => {
                if (e.IsSuccess) {
                  if (!e.Data) {
                    this.mapService.flyToLocation({ map: this.map, latitude: ev.Data.latitude, longitude: ev.Data.longitude, scope: this })
                    this.drawField();
                  } else {
                    let { draw, map } = this.mapService.addDrawablePolygon({
                      map: this.map, geojson: e.Data.geoJson, addClickEvent: true, polygonId: "parcel_drawing", scope: this, callback
                    }, this.deviceType)
                    this.draw = draw;
                    this.map = map;
                    this.isCreated = true
                    this.hintText = mapHintTextListForParcelUpdate;
                    this.mapService.flyToLocation({ map: this.map, longitude: e.Data.geoJson.geometry.coordinates[0][0][0], latitude: e.Data.geoJson.geometry.coordinates[0][0][1], scope: this })
                  }
                } else {
                  this.mapService.flyToLocation({ map: this.map, latitude: ev.Data.latitude, longitude: ev.Data.longitude, scope: this })
                  this.drawField();
                }
              })
            } else {
              this.drawField();
            }
          } else if (e["type"] == "parcelInquery") {
            let response: IGeoJSONObj = this.farmApiService.data
            this.initiateParcelDrawing(response)
          }

        }
      });
  }


  initiateParcelDrawing(props: IGeoJSONObj) {
    let callback = (ev) => {
      this.calculatedArea = this.mapService.calculateArea(ev, this.draw)
    }
    let coords = props.geometry.coordinates[0][0]
    this.parcelGeoJson = props;
    let { draw, map } = this.mapService.addDrawablePolygon({
      map: this.map, geojson: props, addClickEvent: true, polygonId: "parcel_drawing", scope: this, callback
    }, this.deviceType)
    this.draw = draw;
    this.map = map
    this.isCreated = true
    this.hintText = mapHintTextListForParcelUpdate;
    this.mapService.flyToLocation({ map: this.map, latitude: coords[1], longitude: coords[0], scope: this })
  }



  draw
  touchCount = 0
  isCreated: boolean = false
  calculatedArea: number = -1
  drawTypeOptions = {
    render: (ev) => {
      if (this.draw && Array.isArray(this.draw.getAll().features) && this.draw.getAll().features.length > 0) {
        if (!this.isCreated)
          this.hintText = mapHintTextListForDrawing[this.touchCount++] || mapHintTextListForDrawing[mapHintTextListForDrawing.length - 1]
        this.calculatedArea = this.draw ? this.mapService.calculateArea(ev, this.draw) : -1
      } else {
        this.deleteLastVertex()
      }
    },
    create: (ev) => {
      this.isCreated = true
      this.hintText = "tap_drawing_to_update_or_reshape"
      this.calculatedArea = this.draw ? this.mapService.calculateArea(ev, this.draw) : -1
      if (this.calculatedArea === 0)
        this.deleteLastVertex()
    },
    delete: (ev) => {
      this.calculatedArea = this.draw ? this.mapService.calculateArea(ev, this.draw) : -1
    },
    update: (ev) => {
      this.calculatedArea = this.draw ? this.mapService.calculateArea(ev, this.draw) : -1
    }
  }
  drawFieldCallback = (ev) => {
    let type = ev.type.replace("draw.", "")
    let optionEvent = this.drawTypeOptions[type]
    if (optionEvent)
      optionEvent(ev)
  }

  drawingGeojsons: any
  showDeleteBtn: boolean = false
  hasIntersect = false
  drawSubject: Subject<any> = new Subject()
  drawField() {
    this.showHint = true;
    this.showDeleteBtn = false;
    this.touchCount = 0
    this.hintText = mapHintTextListForDrawing[this.touchCount++] || mapHintTextListForDrawing[mapHintTextListForDrawing.length - 1]
    this.drawSubject = new Subject()
    this.mapService.customDrawPolygon({
      map: this.map, scope: this, callback: this.drawFieldCallback
    }, this.deviceType, this.drawSubject.asObservable()).subscribe(drawResponse => {
      if (drawResponse?.data) {
        if (this.hasIntersect)
          this.hasIntersect = this.mapService.checkIfCoordsCross(drawResponse.data.geometry.coordinates)

        this.drawingGeojsons = drawResponse.data
        switch (drawResponse.state) {
          case "start":
            this.showHint = true;
            this.hintText = mapHintTextListForDrawing[this.touchCount++] || mapHintTextListForDrawing[mapHintTextListForDrawing.length - 1]
            this.calculatedArea = this.mapService.calculateAreaFromGeoJson(drawResponse.data)
            break;
          case "render":
            this.showHint = true;
            this.hintText = mapHintTextListForDrawing[this.touchCount++] || mapHintTextListForDrawing[mapHintTextListForDrawing.length - 1]
            this.calculatedArea = this.mapService.calculateAreaFromGeoJson(drawResponse.data)
            break;
          case "finished":
            this.isCreated = true
            this.hintText = "tap_drawing_to_update_or_reshape"
            this.showDeleteBtn = true;
            this.calculatedArea = this.mapService.calculateAreaFromGeoJson(drawResponse.data)
            this.draw = drawResponse.draw
            break;
          case "last_vertex_deleted":
            this.showHint = true;
            if (this.touchCount > 0) {
              this.touchCount--
            }
            this.hintText = mapHintTextListForDrawing[this.touchCount] || mapHintTextListForDrawing[mapHintTextListForDrawing.length - 1]
            this.calculatedArea = this.mapService.calculateAreaFromGeoJson(drawResponse.data)
            break;
          case "linesCrossed":
            this.hasIntersect = true
            setTimeout(() => {
              document.getElementById("intersectBtn").click()
            }, 500);
            break;
          default:
            break;
        }
      }
    }, err => {
    }, () => {
    })
    // this.draw = this.mapService.drawPolygon({
    //   map: this.map, scope: this, callback: this.drawFieldCallback
    // })
  }
  selectPoint() {
    let that = this;
    let callback = (ev) => {
      this.mapService.removeEvent({ map: this.map, eventName: "click", callback } as any)
    }
    this.map = this.mapService.clickToGetCoords({
      map: this.map, scope: this, callback
    });
  }

  deleteLastVertex() {
    if (this.selectedMode === 'manual_drawing') {
      this.drawSubject.next({ state: "delete" });
    } else if (this.selectedMode === 'parcel_inquiry') {
      this.draw.deleteAll()
      this.draw.add(this.parcelGeoJson as any)
      this.isCreated = true;
    }
  }
  deleteDrawing() {
    this.draw.deleteAll();
    this.draw.trash();
    this.calculatedArea = -1;
    this.hasIntersect = false;
    this.map.removeControl(this.draw)
    this.drawingGeojsons = null
    this.draw = null
    this.showDeleteBtn = false
    this.drawField()
  }
  completeDrawing() {
    this.drawSubject.next({ state: "complete" })
  }
  confirmDrawing() {
    if (this.isCreated) {
      let draw = this.draw.getAll();
      let isIntersect = this.mapService.checkIfPolygonLinesCross(this.draw)
      if (this.selectedMode === 'parcel_inquiry') isIntersect = false;
      if (isIntersect) {
        this.modalService.presentModal({
          component: ErrorModalComponent,
          componentProps: {},
          options: ModalService.defaultOptionsTransparent
        })
      } else {
        let drawing = {
          geoJson: draw.features[0],
          calculatedArea: this.calculatedArea
        }
        this.renderBtns = false;
        setTimeout(() => {
          this.renderBtns = true;
        }, 1000);
        this.storageService.set(StorageKeys.DRAWING,drawing).then();
        this.storageService.set(StorageKeys.DRAW, drawing).then(e => {
          this.router.navigate(["/common/enter-device"], {
            queryParams: {
              initialPage: 2,
              deviceId: this.deviceId
            }
          }).then(res => {
            this.drawSubject.complete()

          });
        });


      }
    } else {
      this.modalService.presentModal({
        component: ErrorModalComponent,
        componentProps: {},
        options: ModalService.defaultOptionsTransparent
      })
    }
  }

  isPopoverOpen: boolean = false;
  openIntersectAlert(ev) {
    this.popover.event = ev
    this.isPopoverOpen = true
  }
}
